import { resetCodeState, resetProfile } from '../actions';
import { API } from '../configs/AxiosConfig';
import { store } from '../configs/Store';
import axios from 'axios';

export const removeLoginAccess = () => {
	store.dispatch(resetCodeState());
	store.dispatch(resetProfile());
}

const setHeader = () => {
	const accessToken = store.getState().general.accessToken;
	const language = store.getState().general.language;
	if(accessToken){
		API.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
	}else{
		delete API.defaults.headers.common['Authorization'];
	}
	API.defaults.headers.common['Language'] = language === 'cn' ? 'cn' : 'en';
	API.defaults.headers.common['Site'] = 'Member';
	return true;
}

export const getUrl = async (url, param) => {
	setHeader();
	let result = [];
	await API.get(url, {params: param})
	.then((response) => {
		result = response;
	}).catch((error) => {
		return Promise.reject(error.message);
	});
	return result;
}

export const postUrl = async (url, postData) => {
    setHeader();
    let result = [];
    await API.post(url, postData)
    .then((response) => {
        result = response;
    }).catch((error) => {
        return Promise.reject(error.message);
    });
    return result;
}

// Send FormData without custom headers to avoid CORS preflight (for public endpoints like send_mail)
export const postPublicForm = async (url, formData) => {
	try {
		let endpoint;
		if (url.startsWith('http')) {
			endpoint = url;
		} else if (url.startsWith('/')) {
			// Use same-origin for reverse proxy paths like /api/...
			endpoint = url;
		} else {
			endpoint = `${process.env.REACT_APP_API_URL}/${url}`;
		}
		const res = await axios.post(endpoint, formData, {
			// No custom headers; allow browser to set Accept and Content-Type with boundary
			headers: {}
		});
		// Match API instance behavior by returning data payload
		return res.data;
	} catch (error) {
		return Promise.reject(error.message);
	}
}

export const putUrl = async (url, putData) => {
	setHeader();
	let result = [];
	await API.put(url, putData)
	.then((response) => {
		result = response;
	}).catch((error) => {
		return Promise.reject(error.message);
	});
	return result;
}

export const deleteUrl = async (url) => {
	setHeader();
	let result = [];
	await API.delete(url)
	.then((response) => {
		result = response;
	}).catch((error) => {
		return Promise.reject(error.message);
	});
	return result;
}

export const loginGame = async () => {
	postUrl('/game-login').then(response => {
		if (response.status) {
			let url = new URL(response.data.url);
			url.searchParams.set('token', atob(response.data.token));
			window.open(url.toString(), "_blank", "noreferrer");
		} else {
			alert(response.message);
		}
	}).catch((error) => {
		alert(error.message || "Please try again later or contact admin if problem persist.");
	});
}